import styled, { css } from 'styled-components';

export const CalendarWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 500px;
  margin: 0 auto;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const DaysOfWeek = styled.div`
  margin: 8px 0;
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  text-align: center;
  background-color: #ffff;
  padding: 5px 0;
  font-family: 'Mangueira Medium', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 21px;
  color: #636363;
`;

type DayProps = {
  isToday?: boolean;
  isSelected?: boolean;
  isInRange?: boolean;
  isStartDate?: boolean;
  isEndDate?: boolean;
  isCurrentMonth?: boolean;
};

export const Day = styled.div<DayProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  cursor: pointer;
  font-family: 'Mangueira Medium', sans-serif;
  color: #3d3d3d;

  ${({ isToday, isInRange }) =>
    isToday &&
    !isInRange &&
    css`
      background-color: #f6f7f9;
      border-radius: 50%;
    `}

  ${({ isSelected }) =>
    isSelected &&
    css`
      background-color: royalblue;
      color: white;
    `}

  ${({ isInRange }) =>
    isInRange &&
    css`
      background-color: #e0edff;
    `}

  ${({ isStartDate }) =>
    isStartDate &&
    css`
      background-color: #0b29fb;
      color: #ffffff;
      border-top-left-radius: 8px;
      border-bottom-left-radius: 8px;
      border-top-right-radius: unset;
      border-bottom-right-radius: unset;
    `}

  ${({ isEndDate }) =>
    isEndDate &&
    css`
      background-color: #0b29fb;
      color: #ffffff;
      border-top-right-radius: 8px;
      border-bottom-right-radius: 8px;
      border-top-left-radius: unset;
      border-bottom-left-radius: unset;
    `}

    ${({ isStartDate, isEndDate }) =>
    isStartDate &&
    isEndDate &&
    css`
      background-color: #0b29fb;
      border-radius: 8px;
    `}

    ${({ isCurrentMonth, isStartDate, isEndDate }) =>
    !isCurrentMonth &&
    !isStartDate &&
    !isEndDate &&
    css`
      color: #cbcbcb;
    `}

  &:hover {
    background-color: #e0edff;
  }
`;

export const DaysContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 4px 0;
`;

export const ButtonNexPrevMonth = styled.button`
  all: unset;
  background: transparent;
  border: 1px solid #dce0e5;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
`;

export const MonthName = styled.span`
  font-family: 'Mangueira Medium', sans-serif;
  font-weight: 500;
  font-size: 15px;
  line-height: 21px;
  color: #3d3d3d;
  text-transform: capitalize;
`;

export const ButtonNextPrevWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;
